module.exports = __webpack_public_path__ + "img/maps-pin-1.c0eb91b8.svg";